__turbopack_context__.v({
  "controlBar": "Firt0W_controlBar",
  "controlButton": "Firt0W_controlButton",
  "embedContainer": "Firt0W_embedContainer",
  "fadeInSlideUp": "Firt0W_fadeInSlideUp",
  "minimized": "Firt0W_minimized",
  "spacer": "Firt0W_spacer",
  "streamContainer": "Firt0W_streamContainer",
  "streamHeader": "Firt0W_streamHeader",
  "streamHeaderButton": "Firt0W_streamHeaderButton",
  "streamHeaderText": "Firt0W_streamHeaderText",
});
